<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload,
      browsers: {}
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  mounted () {
    if (this._isMobile()) {
      // 是手机端，需要将页面切换成手机端路由
      window.location.href = 'http://plantcg.nmzp.com/'
    } else {
      // 是pc端，需要将页面切换到pc端路由
      // window.location.href = 'http://www.nmzp.com/'
    }
  },
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style>
  @import 'assets/css/all.css';
</style>



// WEBPACK FOOTER //
// src/App.vue